import { ILand } from "@/modules/pe-fest-module/data/interfaces"
import { Position } from "@blueprintjs/core"
import { IUser, THEME_NAMES } from "src/settings/zustand"
import { SCALAR_TYPES } from "../scalars"
import { ANIMATED_STYLE } from "./animated"


import __small from "../../assets/img/small.svg"
import __mobile from "../../assets/img/mobile.svg"
import __tablet from "../../assets/img/tablet.svg"
import __screen from "../../assets/img/screen.svg"
import __large from "../../assets/img/large.svg"
import __panel from "../../assets/img/panel.svg"
import __alphabet_icon from "../../assets/img/sort-alpha-down.svg"
import __rating_icon from "../../assets/img/ranking-stars.svg"
import __numerical_icon from "../../assets/img/sort-numeric-down.svg"

export enum LOGIN_MODE {
    EXTERNAL    = "EXTERNAL",
    LOGIN       = "LOGIN",
    HIDDEN      = "HIDDEN"
}
export interface IDictionary {
    [key: string] : string
}

export enum LAND_TYPE {
    EVENT       = "EVENT",
    PLACE       = "PLACE",
    TEAM        = "TEAM",
    TREASURY    = "TREASURY",
}

export enum INVITE_TYPE {
    NONE        = "NONE",
    AUTO        = "AUTO",
    ONLY        = "ONLY",
    MAY_BE      = "MAY_BE",
}

export enum INVITE_STATUS {
    NONE        = "NONE",
    WAITING     = "WAITING", 
    AGREED      = "AGREED",
    WITHDRAWN   = "WITHDRAWN",
}
export interface ILandUserInvite {
    id: ID,
    user?: IUser,
    land?: ILand,
    land_id?: ID,
    user_id: ID, 
    status: INVITE_STATUS
    __typename?: string
}

export interface ILayoutData {
    template:           any
    app:                IAppData
    folders:            any
    widgets:            any
    extentions:         any
    views:              any
    ['widget-area']:    any
    routing:            IRoutingData
    modules:            any
    schema:             IDataTypeField
}
export interface IAppData {
    title: string | null
    name: string | null
    coords?: number[]
    image: string | null
    subtitle: string | null
    description: string | null
    external_systems: EXTERNAL_SYSTEM[]
    scopes: string | null
    adapter: string | null
    user_model: string | null
    help_url: string | null
    init_method: string | null
    roles: string[]
    email: string | null
    adress: string | null
    user_verify_account: string | null
    vk: string | null
    youtube: string | null
    android: string | null
    apple: string | null
    vk_app_id: string | null 
    default_login: LOGIN_MODE
    land_group_id?: string
    is_custom_http_header?: boolean
    is_register?: boolean
}
export enum EXTERNAL_SYSTEM {
    vk="vk",
    yandex="yandex",
    telegram="telegram",
}


export interface IRoutingData {  
    [partName: string]: IMenuItemField  
    extended_routes:    IMenuItemField
    menu:               IMenuItemField
    main_menu:          IMenuItemField
    footer:             IMenuItemField
    profile:            IMenuItemField            
    link:               IMenuItemField 
}
export enum LayoutsTags {
    template = "template",
    folders = "folders",
    widgetArea = "widget-area",
    routing = "routing",
    modules = "modules",
    schema = "schema"
}

export type ID = string | number
export type Date = string | number
export type URL = string
export type Icon = URL | string
export type Role = string
export type HTML = string
export type Json = string
export type Color = string
export type Email = string
export type Phone = string

export interface IPossessions {
    [ key: string ]: IUser
}

export interface ILandGroup extends IPost {
    
}

export interface IMousePosition {
    x: number
    y: number
}

// https://stackoverflow.com/questions/72561941/not-in-keyof-in-typescript-generics
export type Merge<X, Y> = {
    [K in (keyof X | keyof Y)]:
        (K extends keyof X ? X[K] : never)
        | (K extends keyof Y ? Y[K] : never)
};

export interface IMedia extends IPost {

}

export interface ILayoutBodyProps {
    [partName: string]: any  
    current?: number
    onCurrent?: () => {}
    onChangeStyle?: () => {}
}

export enum APOLLO_FIELD_FILTER_TYPE {
    TAXONOMIES="taxonomies",
    META="meta"
}

export interface IMetaFilter {
    key: string
    value: string | number | any | string[]
    compare?: string
}
export interface IImageData {
    src: URL,
    width: number,
    height: number,
    aspect: number
}
export interface ITaxonomyFilter {
    tax_name: string
    term_ids: Number[]
}

export interface IPaging {
    metas?: IMetaFilter[]
    offset?: number
    count?:number
    taxonomies?: ITaxonomyFilter []
    in__roles?: Role[]
    relation?: "OR" | "AND"
    meta_relation?: "OR" | "AND"
    order?: string
    order_by_meta?: string
    is_admin?: boolean
    search?: string,
    post_status?: POST_STATUS
}

export interface HelpYoutube {
    url: URL
    title: string
    description? : string
}

export interface IMenuItem {
    id: ID
    children? : any[] 
    html?: string
    html_source?: string
    component?: string
    singled_data_type?: string
    feed_data_type?: string 
    single_data_type?: string
    data_type? : string
    isDisable?: boolean
    route : string // inner link OR outer url OR anchor
    parent?: string
    route_matrix?: string[]
    route_filters?:any
    realRoute?  : string
    icon? : string
    title: string
    description : string
    i?: number
    is_hidden: boolean
    current?: number
    parent_route?: any
    extend_params?: any | null 
    folder?: number
    hide_title?: boolean
    is_cabinet?: boolean
    menu?: string
    module: string
    thumbnail?: URL
    islogged?: boolean
    capability?: Role[]
    redirect?: any
    is_left?: boolean
    target_id?: string 
    aside? : any  
    help_url? : URL
    helps?: HelpYoutube[]
    childRoutes?: string[]
    animated?: ANIMATED_STYLE,
    animated_delay?: MENU_ANIMATE_DELAY | string | number
    className?: string
}

export enum MENU_ANIMATE_DELAY {
    NONE="",
    WATERFALL="waterfall",

}
export interface IMenuItemField {
    [name:string]: IMenuItem
}
export const MENU_VIEW_TYPES: any  = {
    HTML: {
        _id:    "html",
        title:  "Simple editible html-content"
    }, 
    COMPONENT: {
        _id:    "component",
        title:  "Special component"
    },
    HTML_SOURCE: {
        _id:    "html_source",
        title:  "Outer html sourse by URL"
    },
    SINGLED_DATA_TYPE: {
        _id:    "singled_data_type",
        title:  "Visualizator of single item by Data Type"
    },
    FEED_DATA_TYPE: {
        _id:    "feed_data_type",
        title:  "Feed of items by Data Type"
    },
    SINGLE_DATA_TYPE: {
        _id:    "single_data_type",
        title:  "Edit form of item by Data Type for administrator's panel"
    },
    DATA_TYPE: {
        _id:    "data_type",
        title:  "Feed of items by Data Type for admistrators panel"
    },
}
export type IGeoPosition = {
    [partName: string]: any
}
export interface IImageElement {
    width: number
    height: number
    result: any
}

export enum POST_STATUS {
    ALL="all",
    PUBLISH ="publish",
    TRASH = "trash",
    DRAFT = "draft",
    FUTURE="future",
    PENDING="pending"
}
export interface HasId {
    readonly id: ID
    readonly ID?: ID
}
export interface HasTitle {
    title: string | HTML
}
export interface HasComments {
    comments?: IComment[]
}

export interface IPost {
    readonly id: ID
    readonly ID?: ID
    title: string
    post_content: HTML
    content?: HTML
    thumbnail?: URL
    thumbnail_id?: ID
    thumbnail_name?: string
    post_author? : IUser
    post_status?: POST_STATUS
    parent?:IPost
    post_date?: string
    order? :number
    land?: ILand
    likes?: ILike[]
    comments?: IComment[]
    attachments?: IAttachment[]
    bookmarks?: IUser[]
    images?: URL[]
    [key: string]: any
    __typename?: string
}

export interface IPostInput { 
    title: string
    post_content: HTML
    content?: HTML
    thumbnail?: URL
    thumbnail_id?: ID
    thumbnail_name?: string
    post_author? : IUser
    post_status?: POST_STATUS
    post_date?: string
    order? :number
    likes?: ILike[]
    comments?: IComment[]
    [key: string]: any
    __typename?: string
}
export interface ITax extends IPost {
    order: number
}
export interface IComment {
    id:ID
    discussion_id: ID
    discussion_type: string
    discussion: IPost
    content: HTML
    parent?: IComment
    author: IUser
    title? : string
    date?:number
    is_approved?: boolean
    thumbnail?: string
}
export interface ILike { 
    user?: IUser
    type: LIKE_TYPE 
}


export enum LIKE_TYPE {
    LIKE="LIKE",
    FIRE="FIRE",
    CLOWN="CLOWN",
    UP="UP",
    DOWN="DOWN",
    ANGRY="ANGRY",
    NONE="NONE"
}
export interface IPEMessage extends IPost {
    resource_title?: string
    resource_type?: string
    resource_id?: ID
    is_viewed: boolean
    adressee?: IUser

}
export interface IPENotification extends IPost {
    resource_title?: string
    resource_type?: string
    resource_id?: ID
    is_viewed: boolean
    land?: ILand
    adressee?: IUser
}

export enum COLOR_TYPE {
    PLAIN="PLAIN",
    GRADIENT="GRADIENT",
    PANTONE="PANTONE"
}


export interface VK_URL {
    url : URL
    title: string
    site_name: string
    description: string
    image: URL
}
export interface IPEVKPost extends IPost {
    like_count?: number
    comment_count?: number
    reposts_count?: number
    images?: URL[]
    link: URL
    url?: VK_URL
}

export interface IApolloData {
    filter: any
    order_by_meta: any
    fill: Color[]
} 



export interface IAppoloField {
    name?:string
    type: SCALAR_TYPES | string
    title: string
    thread: boolean | number
    editable: boolean | number
    hidden?: boolean
    hide_query?: boolean
    field_footer?: string
    filter_type?: APOLLO_FIELD_FILTER_TYPE
    values?: any[]
    component?: string
    isURLHide?: boolean | number
    col_width?: number
    col_icon?: string
    external_fields?: string[]
    visibled_value?: string
    single?: boolean | number
    enum?: string // for type=checkbox
    pseudonym?: string // wp tax name
    tag_footer_color?: string
    kind?: string
    tab?: string
    isHidden?: boolean
    hide_by_child?: boolean
    subfields?: string[]
}
export interface IAppoloFields { 
    [fieldName: string]: IAppoloField
}
export interface IDataType {
    admin_data: IApolloData
    apollo_fields: IAppoloFields
    visibled_value: string
    type: string
    kind?: string
    component?: string
    admin_view? : string
    feed_view? : string 
    name: string
    plural?: string
    module: string
    childRoutes? : string[]
    hidden?: boolean
    icon?: URL
    feed_layout?: string
}
export interface IDataTypeField {
    [fieldName: string]: IDataType
}

export const DefaultLayoutTemplateAside = {
    bg: "transparent",
    color: "#444",
    active: "#660000" 
}
export interface ILayoutTemplateAside {
    bg:  Color
    color:  Color
    active:  Color
}
export interface IFlap {
    position: Position
    size: string /* "50%" */
    thumbnail?: URL
} 
export interface ILayoutTemplateExtendParams { 
    bgThumbnail?: URL
    bgBlur?: 1|2|3|4|5|6|7|8|9|10
    backgroundColor?: Color
    color?: Color
    bgOpacity?: Number /* 0 - 1 */
    flap?: IFlap
} 
export type ILayoutTemplate = {
    menu_left: boolean
    main_left: ILayoutTemplateAside | false
    left: ILayoutTemplateAside| false
    is_left: boolean
    is_right: boolean
    header: ILayoutTemplateAside | false
    footer: ILayoutTemplateAside | false
    icon: Icon
    icon_width: number
    icon_height: number
    icon_background: Color
    avatar: Icon
    login: string | "/login"
    style: URL | string 
    default_img: URL
    thumbnail: Icon
    header_menu: "iconic" | ""
    header_menu_height: number
    left_menu: "pictogramm" | "hierarhical"
    extend_params: ILayoutTemplateExtendParams
}

export const templateTypes = (): any => {
    return {
        menu_left: {
            id: "menu_left",
            title: "Left Menu",
            commentary: "",
            type: SCALAR_TYPES.BOOLEAN,
            visualization: "layout-template-aside-scalars",
            notClear: true,
            tab: "Layout"
        },
        main_left: {
            id: "main_left",
            title: "Top Menu",
            commentary: "",
            type: SCALAR_TYPES.BOOLEAN,
            visualization: "layout-template-aside-scalars", 
            notClear: true,
            tab: "Layout"
        },
        left: {
            id: "left",
            title: "Left Menu Aside",
            commentary: "",
            type: SCALAR_TYPES.BOOLEAN,
            visualization: "layout-template-aside-scalars",
            notClear: true,
            tab: "Layout"
        }, 
        right: {
            id: "right",
            title: "Right Menu Aside",
            commentary: "",
            type: SCALAR_TYPES.BOOLEAN,
            visualization: "layout-template-aside-scalars",
            notClear: true,
            tab: "Layout"
        }, 
        header: {
            id: "header",
            title: "Header",
            commentary: "",
            type: SCALAR_TYPES.BOOLEAN,
            visualization: "layout-template-aside-scalars",
            notClear: true,
            tab: "Layout"
        },  
        footer: {
            id: "footer",
            title: "footer",
            commentary: "",
            type: SCALAR_TYPES.BOOLEAN,
            visualization: "layout-template-aside-scalars",
            notClear: true,
            tab: "Layout"
        }, 
        icon: {
            id: "icon",
            title: "Icon",
            commentary: "",
            type: SCALAR_TYPES.MEDIA,
            tab: "Head"
        },  
        icon_width: {
            id: "icon_width",
            title: "Icon width",
            commentary: "",
            min: 20,
            max:400,
            type: SCALAR_TYPES.SLIDER,
            stepSize:1,
            labelStepSize:25,
            tab: "Head"
        },   
        icon_height: {
            id: "icon_height",
            title: "Icon height",
            commentary: "",
            min: 20,
            max:100,
            type: SCALAR_TYPES.SLIDER,
            stepSize:1,
            labelStepSize:10,
            tab: "Head"
        },   
        icon_background: {
            id: "icon_background",
            title: "Icon's background",
            commentary: "",
            type: SCALAR_TYPES.COLOR,
            tab: "Head"
        },  
        avatar: {
            id: "avatar",
            title: "Default avatar",
            commentary: "",
            type: SCALAR_TYPES.MEDIA,
            tab: "Over"
        },   
        login: {
            id: "login",
            title: "Login path",
            commentary: "",
            type: SCALAR_TYPES.STRING,
            default: "/login",
            tab: "Over"
        },    
        style: {
            id: "style",
            title: "Style URL",
            commentary: "",
            type: SCALAR_TYPES.RADIO,
            values: [
                {
                    _id:"/assets/css/style.css",
                    title: "Default"
                },
                {
                    _id:"/assets/css/style_light.css",
                    title: "Light"
                },
                {
                    _id:"/assets/css/style_minimal.css",
                    title: "Minimal"
                },
            ],
            default: "/assets/css/style.css",
            tab: "Over"
        },   

        // default_img: {
        //     id: "default_img",
        //     title: "Default Image background",
        //     commentary: "",
        //     type: SCALAR_TYPES.MEDIA, 
        //     height: 250,
        //     tab: "Over"
        // },    
        // thumbnail: {
        //     id: "thumbnail",
        //     title: "Thumbnail",
        //     commentary: "",
        //     height: 250,
        //     type: SCALAR_TYPES.MEDIA, 
        //     tab: "Over"
        // },    

        header_menu : {
            id: "header_menu",
            title: "header menu type",
            commentary: "",
            type: SCALAR_TYPES.IMAGE_RADIO,
            values: [
                {
                    _id:"iconic",
                    title: "Iconic",
                    img: "/assets/img/admin/header-menu-title1.svg",
                    height: 100
                }, 
                {
                    _id:"linic",
                    title: "Linear",
                    img: "/assets/img/admin/header-menu-title2.svg",
                    height: 100
                },
            ],
            default: "iconic",
            tab: "Head"
        },     
        header_menu_height: {
            id: "header_menu_height",
            title: "header menu height",
            commentary: "",
            type: SCALAR_TYPES.NUMBER,
            tab: "Head" 
        },    
        left_menu: {
            id: "left_menu",
            title: "Left menu type",
            commentary: "",
            type: SCALAR_TYPES.IMAGE_RADIO,
            values: [
                {
                    _id:"pictogramm",
                    title: "pictogramm",
                    img: "/assets/img/admin/header-menu-title1.svg",
                    height: 100
                }, 
                {
                    _id:"hierarhical",
                    title: "hierarhical",
                    img: "/assets/img/admin/header-menu-title2.svg",
                    height: 100
                },
            ],
            default: "iconic",
            tab: "Over"
        },
        extend_params: {
            title: "Extended parameters",
            description: "Default design parameters of every View (background, colors)",
            type: SCALAR_TYPES.BOOLEAN,
            visualization: "extend-params-scalars",
            tab: "Default Views design"

        }
    }
}
export interface IWidget {
    title: string
    description: string
    module: string
    is_cabinet?: boolean
    preority: number
    area: IWidgetNest[]
    fields: IWidgetAreaField[]
}
export interface IWidgetNest {
    component : string
    [key: string] : any
}
export interface IWidgetAreaField {
    title: string
    type: SCALAR_TYPES
    default?: any
}
export interface IWidgetArea {
    title: string
    description: string
    preority: number
    area: IWidgetNest[]
    fields? : IWidgetAreaField[]
    module: string
}

export interface IModule {
    title: string
    description: string
    commentary: string
    id: string
    required : string[]
    icon: URL
    preority: number
    version: string
    author: string
    color: Color
    documentation: URL
    git: URL
    views: any      // IView[]
    widgets: any    // IWidget[]
    extentions: any
    ["widget-area"]: any
    assets: any
    schema: any
    routing: any
}

export interface VKVideoItem {
    src: URL
    image?: URL | string
    label?: HTML
    content?: HTML
    onEnded?: () => void
}

export interface ICategory extends IPost {

}
export interface IAttachment extends IPost {
    resource_id: number
    resource_type: string
    type: string
    data: string
    category?: ICategory[]
}

export interface IMagnitude {
    value?: number;
    units?: CSS_UNITS
}

export interface CSSBorder {
    borderWidth: number,
    borderStyle: BORDER_STYLE,
    borderColor: Color
    borderRound: CSSBorderRadius
}
export interface CSSBorderRadius {
    border: number
    borderTopRight?: number
    borderBottomLeft?: number
    borderBottomRight?: number

}

export enum BORDER_STYLE {
    SOLID="solid",
    DOTTED="dotted",
    DASHED="dashed",
    NONE="none",
}

export enum CSS_UNITS {
    PX="px",
    NONE="",
    DVH="dvh",
    VH="vh",
    DVW="dvw",
    VW="vw",
    PERCENTAGE="%",
}

export enum DIALOG_SIZE {
    MICRO="micro",
    MINIMAL="minimal",
    LITTLE="little",
    COMPACT="compact",
    NORMAL="normal", 
    LARGE="large",
    FULL="full"
}
export const CONTAINER_SIZE = {
    [DIALOG_SIZE.MICRO] : 370,    
    [DIALOG_SIZE.MINIMAL] : 570,    
    [DIALOG_SIZE.LITTLE] : 870,    
    [DIALOG_SIZE.COMPACT] : 1070,    
    [DIALOG_SIZE.NORMAL] : 1270,         
    [DIALOG_SIZE.LARGE] : 1770,//"calc(100% - 70px)",    
    [DIALOG_SIZE.FULL] : "calc(100% - 30px)", 
}
export const CONTAINER_CONTAINER = {
    [DIALOG_SIZE.MICRO] : "micro-container",    
    [DIALOG_SIZE.MINIMAL] : "small-container",    
    [DIALOG_SIZE.LITTLE] : "short-container",   
    [DIALOG_SIZE.COMPACT] : "compact-container",     
    [DIALOG_SIZE.NORMAL] : "container",         
    [DIALOG_SIZE.LARGE] : "large-container",    
    [DIALOG_SIZE.FULL] : "container-fluid", 
}


export enum WINDOW_WIDTH { 
    PANEL   = 1920,
    LARGE   = 1200,
    SCREEN  = 992,
    TABLET  = 768,
    MOBILE  = 540,
    SMALL   = 360
}

export const WINDOW_ICON = {
    SMALL : __small,    
    MOBILE : __mobile,    
    TABLET : __tablet,    
    SCREEN : __screen,        
    LARGE : __large,    
    PANEL : __panel, 
}

export enum FRAME_TRANSITION_TYPE {
    MOVE_DOWN="MOVE_DOWN",
    MOVE_UP="MOVE_UP",
    FADE="FADE"
}

export enum LOADING_STATUS {
    SUCCESS_RESULT,
    LOADING,
    NULL_RESULT,
    SECONDARY_LOADING
}


export const VIDEO_SEPARATOR = "@#$@#$@#$"

export enum VIDEO_HOSTING_TYPE {
    YOUTUBE="YOUTUBE",
    VK="VK",
    RUTUBE="RUTUBE"
}

export enum VIDEO_RATIO {
    "21_9"=2.39,
    "16_9"=1.77,
    "4_3"=1.3,
    "1_1"=1.0,

}

export enum SHORTCODE_TYPE {
    "BUTTON" = "BUTTON",
    "INSERT" = "INSERT",
    "VK_VIDEO" = "VK_VIDEO",
    "MAP" = "MAP",
    "GALLERY" = "GALLERY",
    "DIALOG" = "DIALOG",
    "LINK" = "LINK",
}

export enum ATTACHMENT_CARD_TYPE {
    "CARD" = "CARD",
    "STROKE" = "STROKE",
    "PLATE" = "PLATE",
}

export enum SC {
    VK="vk",
    LINK="link",
    ODNOKLASNIKI="odnoklassniki",
    DZEN="dzen",
    RUTUBE="rutube",
    TELEGRAM="telegram",
    MAX="max",
    YANDEX="yandex",
    AT="at" //email
}

export const SC_DATA = {
    [SC.VK]: {
        title: "VKontakte",
        color: "#4c75a3",

    },
    [SC.LINK]: {
        title: "Link",
        color: "#2db642",

    },
    [SC.ODNOKLASNIKI]: {
        title: "odnoklassniki",
        color: "#e69743",

    },
    [SC.YANDEX]: {
        title: "yandex",
        color: "#b43a3a",

    },
    [SC.DZEN]: {
        title: "Dzen",
        color: "#f44432",

    },
    [SC.RUTUBE]: {
        title: "Rutube",
        color: "#255aa8ff",

    },
    [SC.TELEGRAM]: {
        title: "Telegram",
        color: "#64b1ec",

    },
    [SC.MAX]: {
        title: "Max",
        color: "#305b8bff",

    },
    [SC.AT]: {
        title: "Email",
        color: "#237ba7ff",

    },
}

export const PALETTE = {
    [THEME_NAMES.DAY]: {
        CONTRAST: "#010101",
        PLAIN: "#FFFFFF",
        SECONDARY_PLAIN: "#AAAAAA77",
        SECONDARY_CONTRAST: "#46627e33",
    },
    [THEME_NAMES.EVENING]: {
        CONTRAST: "#010101",
        PLAIN: "#FFFFFF",
        SECONDARY_PLAIN: "#AAAAAA77",
        SECONDARY_CONTRAST: "#181e247e",
    },
    [THEME_NAMES.NIGHT]: {
        CONTRAST: "#e1e1e1",
        PLAIN: "#181e24",
        SECONDARY_PLAIN: "#46627e",
        SECONDARY_CONTRAST: "#FFFFFF7e",
    },
    
}
export enum PANTONES {
    BACKGROUND="--main-bg-color",
    CONTRAST="--force-contast-color",
    OPACITY_CONTRAST="--force-contrast-opacity-color",
    SECONDARY_OPACITY_CONTRAST="--force-contrast-secondary-opacity-color",
    MINI_OPACITY_CONTRAST="--force-mini-contast-color",

    PLAIN="--force-plain-color",
    OPACITY_PLAIN="--force-plain-secondary-color",
    FULL_OPACITY_PLAIN="--force-plain-full-opacity-color",

    DARK="--force-dark-color",
    MORE_DARK="--force-more-dark-color",

    SELECT="--drop-select-color",
    SUCCESS="--actual-success-color",
    DANGER="--red",
    INDIGO="--indigo",
    PINK="--pink",
    ORANGE="--orange",
    YELLOW="--yellow",
    CYAN="--cyan",

}

export enum SORT_TYPE {
    ORDER="order",
    ALPHABET="alphabet",
    RATING="rating",
}

type SortTypeElement = {
    icon: string
    label: string
}
type SortTypeType = { 
    [key in SORT_TYPE]: SortTypeElement 
}

export const SortTypeData: SortTypeType = {
    [ SORT_TYPE.ALPHABET ]: {
        icon: __alphabet_icon,
        label: "by alphabetical", 
    },
    [ SORT_TYPE.ORDER ]: {
        icon: __numerical_icon,
        label: "By order", 
    },
    [ SORT_TYPE.RATING ]: {
        icon: __rating_icon,
        label: "By rating", 
    },
}

export const ACCESS_COOKIES_DELAY: number = 259200000

// https://fontawesome.com/v5/cheatsheet/free
export const FaBrandsIcon = [
    "fab fa-500px", "fab fa-accessible-icon", "fab fa-accusoft", "fab fa-acquisitions-incorporated", "fab fa-adn", "fab fa-adversal", "fab fa-affiliatetheme", "fab fa-airbnb", "fab fa-algolia", "fab fa-alipay", "fab fa-amazon", "fab fa-amazon-pay", "fab fa-amilia", "fab fa-android", "fab fa-angellist", "fab fa-angrycreative", "fab fa-angular", "fab fa-app-store", "fab fa-app-store-ios", "fab fa-apper", "fab fa-apple", "fab fa-apple-pay", "fab fa-artstation", "fab fa-asymmetrik", "fab fa-atlassian", "fab fa-audible", "fab fa-autoprefixer", "fab fa-avianex", "fab fa-aviato", "fab fa-aws", "fab fa-bandcamp", "fab fa-battle-net", "fab fa-behance", "fab fa-behance-square", "fab fa-bimobject", "fab fa-bitbucket", "fab fa-bitcoin", "fab fa-bity", "fab fa-black-tie", "fab fa-blackberry", "fab fa-blogger", "fab fa-blogger-b", "fab fa-bluetooth", "fab fa-bluetooth-b", "fab fa-bootstrap", "fab fa-btc", "fab fa-buffer", "fab fa-buromobelexperte", "fab fa-buy-n-large", "fab fa-buysellads", "fab fa-canadian-maple-leaf", "fab fa-cc-amazon-pay", "fab fa-cc-amex", "fab fa-cc-apple-pay", "fab fa-cc-diners-club", "fab fa-cc-discover", "fab fa-cc-jcb", "fab fa-cc-mastercard", "fab fa-cc-paypal", "fab fa-cc-stripe", "fab fa-cc-visa", "fab fa-centercode", "fab fa-centos", "fab fa-chrome", "fab fa-chromecast", "fab fa-cloudflare", "fab fa-cloudscale", "fab fa-cloudsmith", "fab fa-cloudversify", "fab fa-codepen", "fab fa-codiepie", "fab fa-confluence", "fab fa-connectdevelop", "fab fa-contao", "fab fa-cotton-bureau", "fab fa-cpanel", "fab fa-creative-commons", "fab fa-creative-commons-by", "fab fa-creative-commons-nc", "fab fa-creative-commons-nc-eu", "fab fa-creative-commons-nc-jp", "fab fa-creative-commons-nd", "fab fa-creative-commons-pd", "fab fa-creative-commons-pd-alt", "fab fa-creative-commons-remix", "fab fa-creative-commons-sa", "fab fa-creative-commons-sampling", "fab fa-creative-commons-sampling-plus", "fab fa-creative-commons-share", "fab fa-creative-commons-zero", "fab fa-critical-role", "fab fa-css3", "fab fa-css3-alt", "fab fa-cuttlefish", "fab fa-d-and-d", "fab fa-d-and-d-beyond", "fab fa-dailymotion", "fab fa-dashcube", "fab fa-deezer", "fab fa-delicious", "fab fa-deploydog", "fab fa-deskpro", "fab fa-dev", "fab fa-deviantart", "fab fa-dhl", "fab fa-diaspora", "fab fa-digg", "fab fa-digital-ocean", "fab fa-discord", "fab fa-discourse", "fab fa-dochub", "fab fa-docker", "fab fa-draft2digital", "fab fa-dribbble", "fab fa-dribbble-square", "fab fa-dropbox", "fab fa-drupal", "fab fa-dyalog", "fab fa-earlybirds", "fab fa-ebay", "fab fa-edge", "fab fa-edge-legacy", "fab fa-elementor", "fab fa-ello", "fab fa-ember", "fab fa-empire", "fab fa-envira", "fab fa-erlang", "fab fa-ethereum", "fab fa-etsy", "fab fa-evernote", "fab fa-expeditedssl", "fab fa-facebook", "fab fa-facebook-f", "fab fa-facebook-messenger", "fab fa-facebook-square", "fab fa-fantasy-flight-games", "fab fa-fedex", "fab fa-fedora", "fab fa-figma", "fab fa-firefox", "fab fa-firefox-browser", "fab fa-first-order", "fab fa-first-order-alt", "fab fa-firstdraft", "fab fa-flickr", "fab fa-flipboard", "fab fa-fly", "fab fa-font-awesome", "fab fa-font-awesome-alt", "fab fa-font-awesome-flag", "fab fa-fonticons", "fab fa-fonticons-fi", "fab fa-fort-awesome", "fab fa-fort-awesome-alt", "fab fa-forumbee", "fab fa-foursquare", "fab fa-free-code-camp", "fab fa-freebsd", "fab fa-fulcrum", "fab fa-galactic-republic", "fab fa-galactic-senate", "fab fa-get-pocket", "fab fa-gg", "fab fa-gg-circle", "fab fa-git", "fab fa-git-alt", "fab fa-git-square", "fab fa-github", "fab fa-github-alt", "fab fa-github-square", "fab fa-gitkraken", "fab fa-gitlab", "fab fa-gitter", "fab fa-glide", "fab fa-glide-g", "fab fa-gofore", "fab fa-goodreads", "fab fa-goodreads-g", "fab fa-google", "fab fa-google-drive", "fab fa-google-pay", "fab fa-google-play", "fab fa-google-plus", "fab fa-google-plus-g", "fab fa-google-plus-square", "fab fa-google-wallet", "fab fa-gratipay", "fab fa-grav", "fab fa-gripfire", "fab fa-grunt", "fab fa-guilded", "fab fa-gulp", "fab fa-hacker-news", "fab fa-hacker-news-square", "fab fa-hackerrank", "fab fa-hips", "fab fa-hire-a-helper", "fab fa-hive", "fab fa-hooli", "fab fa-hornbill", "fab fa-hotjar", "fab fa-houzz", "fab fa-html5", "fab fa-hubspot", "fab fa-ideal", "fab fa-imdb", "fab fa-innosoft", "fab fa-instagram", "fab fa-instagram-square", "fab fa-instalod", "fab fa-intercom", "fab fa-internet-explorer", "fab fa-invision", "fab fa-ioxhost", "fab fa-itch-io", "fab fa-itunes", "fab fa-itunes-note", "fab fa-java", "fab fa-jedi-order", "fab fa-jenkins", "fab fa-jira", "fab fa-joget", "fab fa-joomla", "fab fa-js", "fab fa-js-square", "fab fa-jsfiddle", "fab fa-kaggle", "fab fa-keybase", "fab fa-keycdn", "fab fa-kickstarter", "fab fa-kickstarter-k", "fab fa-korvue", "fab fa-laravel", "fab fa-lastfm", "fab fa-lastfm-square", "fab fa-leanpub", "fab fa-less", "fab fa-line", "fab fa-linkedin", "fab fa-linkedin-in", "fab fa-linode", "fab fa-linux", "fab fa-lyft", "fab fa-magento", "fab fa-mailchimp", "fab fa-mandalorian", "fab fa-markdown", "fab fa-mastodon", "fab fa-maxcdn", "fab fa-mdb", "fab fa-medapps", "fab fa-medium", "fab fa-medium-m", "fab fa-medrt", "fab fa-meetup", "fab fa-megaport", "fab fa-mendeley", "fab fa-microblog", "fab fa-microsoft", "fab fa-mix", "fab fa-mixcloud", "fab fa-mixer", "fab fa-mizuni", "fab fa-modx", "fab fa-monero", "fab fa-napster", "fab fa-neos", "fab fa-nimblr", "fab fa-node", "fab fa-node-js", "fab fa-npm", "fab fa-ns8", "fab fa-nutritionix", "fab fa-octopus-deploy", "fab fa-odnoklassniki", "fab fa-odnoklassniki-square", "fab fa-old-republic", "fab fa-opencart", "fab fa-openid", "fab fa-opera", "fab fa-optin-monster", "fab fa-orcid", "fab fa-osi", "fab fa-page4", "fab fa-pagelines", "fab fa-palfed", "fab fa-patreon", "fab fa-paypal", "fab fa-penny-arcade", "fab fa-perbyte", "fab fa-periscope", "fab fa-phabricator", "fab fa-phoenix-framework", "fab fa-phoenix-squadron", "fab fa-php", "fab fa-pied-piper", "fab fa-pied-piper-alt", "fab fa-pied-piper-hat", "fab fa-pied-piper-pp", "fab fa-pied-piper-square", "fab fa-pinterest", "fab fa-pinterest-p", "fab fa-pinterest-square", "fab fa-playstation", "fab fa-product-hunt", "fab fa-pushed", "fab fa-python", "fab fa-qq", "fab fa-quinscape", "fab fa-quora", "fab fa-r-project", "fab fa-raspberry-pi", "fab fa-ravelry", "fab fa-react", "fab fa-reacteurope", "fab fa-readme", "fab fa-rebel", "fab fa-red-river", "fab fa-reddit", "fab fa-reddit-alien", "fab fa-reddit-square", "fab fa-redhat", "fab fa-renren", "fab fa-replyd", "fab fa-researchgate", "fab fa-resolving", "fab fa-rev", "fab fa-rocketchat", "fab fa-rockrms", "fab fa-rust", "fab fa-safari", "fab fa-salesforce", "fab fa-sass", "fab fa-schlix", "fab fa-scribd", "fab fa-searchengin", "fab fa-sellcast", "fab fa-sellsy", "fab fa-servicestack", "fab fa-shirtsinbulk", "fab fa-shopify", "fab fa-shopware", "fab fa-simplybuilt", "fab fa-sistrix", "fab fa-sith", "fab fa-sketch", "fab fa-skyatlas", "fab fa-skype", "fab fa-slack", "fab fa-slack-hash", "fab fa-slideshare", "fab fa-snapchat", "fab fa-snapchat-ghost", "fab fa-snapchat-square", "fab fa-soundcloud", "fab fa-sourcetree", "fab fa-speakap", "fab fa-speaker-deck", "fab fa-spotify", "fab fa-squarespace", "fab fa-stack-exchange", "fab fa-stack-overflow", "fab fa-stackpath", "fab fa-staylinked", "fab fa-steam", "fab fa-steam-square", "fab fa-steam-symbol", "fab fa-sticker-mule", "fab fa-strava", "fab fa-stripe", "fab fa-stripe-s", "fab fa-studiovinari", "fab fa-stumbleupon", "fab fa-stumbleupon-circle", "fab fa-superpowers", "fab fa-supple", "fab fa-suse", "fab fa-swift", "fab fa-symfony", "fab fa-teamspeak", "fab fa-telegram", "fab fa-telegram-plane", "fab fa-tencent-weibo", "fab fa-the-red-yeti", "fab fa-themeco", "fab fa-themeisle", "fab fa-think-peaks", "fab fa-tiktok", "fab fa-trade-federation", "fab fa-trello", "fab fa-tripadvisor", "fab fa-tumblr", "fab fa-tumblr-square", "fab fa-twitch", "fab fa-twitter", "fab fa-twitter-square", "fab fa-typo3", "fab fa-uber", "fab fa-ubuntu", "fab fa-uikit", "fab fa-umbraco", "fab fa-uncharted", "fab fa-uniregistry", "fab fa-unity", "fab fa-unsplash", "fab fa-untappd", "fab fa-ups", "fab fa-usb", "fab fa-usps", "fab fa-ussunnah", "fab fa-vaadin", "fab fa-viacoin", "fab fa-viadeo", "fab fa-viadeo-square", "fab fa-viber", "fab fa-vimeo", "fab fa-vimeo-square", "fab fa-vimeo-v", "fab fa-vine", "fab fa-vk", "fab fa-vnv", "fab fa-vuejs", "fab fa-watchman-monitoring", "fab fa-waze", "fab fa-weebly", "fab fa-weibo", "fab fa-weixin", "fab fa-whatsapp", "fab fa-whatsapp-square", "fab fa-whmcs", "fab fa-wikipedia-w", "fab fa-windows", "fab fa-wix", "fab fa-wizards-of-the-coast", "fab fa-wodu", "fab fa-wolf-pack-battalion", "fab fa-wordpress", "fab fa-wordpress-simple", "fab fa-wpbeginner", "fab fa-wpexplorer", "fab fa-wpforms", "fab fa-wpressr", "fab fa-xbox", "fab fa-xing", "fab fa-xing-square", "fab fa-y-combinator", "fab fa-yahoo", "fab fa-yammer", "fab fa-yandex", "fab fa-yandex-international", "fab fa-yarn", "fab fa-yelp", "fab fa-yoast", "fab fa-youtube", "fab fa-youtube-square", "fab fa-zhihu",
]
export const FaSolidIcon = [
    "far fa-address-book", "far fa-address-card", "far fa-angry", "far fa-arrow-alt-circle-down", "far fa-arrow-alt-circle-left", "far fa-arrow-alt-circle-right", "far fa-arrow-alt-circle-up", "far fa-bell", "far fa-bell-slash", "far fa-bookmark", "far fa-building", "far fa-calendar", "far fa-calendar-alt", "far fa-calendar-check", "far fa-calendar-minus", "far fa-calendar-plus", "far fa-calendar-times", "far fa-caret-square-down", "far fa-caret-square-left", "far fa-caret-square-right", "far fa-caret-square-up", "far fa-chart-bar", "far fa-check-circle", "far fa-check-square", "far fa-circle", "far fa-clipboard", "far fa-clock", "far fa-clone", "far fa-closed-captioning", "far fa-comment", "far fa-comment-alt", "far fa-comment-dots", "far fa-comments", "far fa-compass", "far fa-copy", "far fa-copyright", "far fa-credit-card", "far fa-dizzy", "far fa-dot-circle", "far fa-edit", "far fa-envelope", "far fa-envelope-open", "far fa-eye", "far fa-eye-slash", "far fa-file", "far fa-file-alt", "far fa-file-archive", "far fa-file-audio", "far fa-file-code", "far fa-file-excel", "far fa-file-image", "far fa-file-pdf", "far fa-file-powerpoint", "far fa-file-video", "far fa-file-word", "far fa-flag", "far fa-flushed", "far fa-folder", "far fa-folder-open", "far fa-frown", "far fa-frown-open", "far fa-futbol", "far fa-gem", "far fa-grimace", "far fa-grin", "far fa-grin-alt", "far fa-grin-beam", "far fa-grin-beam-sweat", "far fa-grin-hearts", "far fa-grin-squint", "far fa-grin-squint-tears", "far fa-grin-stars", "far fa-grin-tears", "far fa-grin-tongue", "far fa-grin-tongue-squint", "far fa-grin-tongue-wink", "far fa-grin-wink", "far fa-hand-lizard", "far fa-hand-paper", "far fa-hand-peace", "far fa-hand-point-down", "far fa-hand-point-left", "far fa-hand-point-right", "far fa-hand-point-up", "far fa-hand-pointer", "far fa-hand-rock", "far fa-hand-scissors", "far fa-hand-spock", "far fa-handshake", "far fa-hdd", "far fa-heart", "far fa-hospital", "far fa-hourglass", "far fa-id-badge", "far fa-id-card", "far fa-image", "far fa-images", "far fa-keyboard", "far fa-kiss", "far fa-kiss-beam", "far fa-kiss-wink-heart", "far fa-laugh", "far fa-laugh-beam", "far fa-laugh-squint", "far fa-laugh-wink", "far fa-lemon", "far fa-life-ring", "far fa-lightbulb", "far fa-list-alt", "far fa-map", "far fa-meh", "far fa-meh-blank", "far fa-meh-rolling-eyes", "far fa-minus-square", "far fa-money-bill-alt", "far fa-moon", "far fa-newspaper", "far fa-object-group", "far fa-object-ungroup", "far fa-paper-plane", "far fa-pause-circle", "far fa-play-circle", "far fa-plus-square", "far fa-question-circle", "far fa-registered", "far fa-sad-cry", "far fa-sad-tear", "far fa-save", "far fa-share-square", "far fa-smile", "far fa-smile-beam", "far fa-smile-wink", "far fa-snowflake", "far fa-square", "far fa-star", "far fa-star-half", "far fa-sticky-note", "far fa-stop-circle", "far fa-sun", "far fa-surprise", "far fa-thumbs-down", "far fa-thumbs-up", "far fa-times-circle", "far fa-tired", "far fa-trash-alt", "far fa-user", "far fa-user-circle", "far fa-window-close", "far fa-window-maximize", "far fa-window-minimize", "far fa-window-restore",
]
export const FaRegularIcon = [
    "fas fa-ad", "fas fa-address-book", "fas fa-address-card", "fas fa-adjust", "fas fa-air-freshener", "fas fa-align-center", "fas fa-align-justify", "fas fa-align-left", "fas fa-align-right", "fas fa-allergies", "fas fa-ambulance", "fas fa-american-sign-language-interpreting", "fas fa-anchor", "fas fa-angle-double-down", "fas fa-angle-double-left", "fas fa-angle-double-right", "fas fa-angle-double-up", "fas fa-angle-down", "fas fa-angle-left", "fas fa-angle-right", "fas fa-angle-up", "fas fa-angry", "fas fa-ankh", "fas fa-apple-alt", "fas fa-archive", "fas fa-archway", "fas fa-arrow-alt-circle-down", "fas fa-arrow-alt-circle-left", "fas fa-arrow-alt-circle-right", "fas fa-arrow-alt-circle-up", "fas fa-arrow-circle-down", "fas fa-arrow-circle-left", "fas fa-arrow-circle-right", "fas fa-arrow-circle-up", "fas fa-arrow-down", "fas fa-arrow-left", "fas fa-arrow-right", "fas fa-arrow-up", "fas fa-arrows-alt", "fas fa-arrows-alt-h", "fas fa-arrows-alt-v", "fas fa-assistive-listening-systems", "fas fa-asterisk", "fas fa-at", "fas fa-atlas", "fas fa-atom", "fas fa-audio-description", "fas fa-award", "fas fa-baby", "fas fa-baby-carriage", "fas fa-backspace", "fas fa-backward", "fas fa-bacon", "fas fa-bacteria", "fas fa-bacterium", "fas fa-bahai", "fas fa-balance-scale", "fas fa-balance-scale-left", "fas fa-balance-scale-right", "fas fa-ban", "fas fa-band-aid", "fas fa-barcode", "fas fa-bars", "fas fa-baseball-ball", "fas fa-basketball-ball", "fas fa-bath", "fas fa-battery-empty", "fas fa-battery-full", "fas fa-battery-half", "fas fa-battery-quarter", "fas fa-battery-three-quarters", "fas fa-bed", "fas fa-beer", "fas fa-bell", "fas fa-bell-slash", "fas fa-bezier-curve", "fas fa-bible", "fas fa-bicycle", "fas fa-biking", "fas fa-binoculars", "fas fa-biohazard", "fas fa-birthday-cake", "fas fa-blender", "fas fa-blender-phone", "fas fa-blind", "fas fa-blog", "fas fa-bold", "fas fa-bolt", "fas fa-bomb", "fas fa-bone", "fas fa-bong", "fas fa-book", "fas fa-book-dead", "fas fa-book-medical", "fas fa-book-open", "fas fa-book-reader", "fas fa-bookmark", "fas fa-border-all", "fas fa-border-none", "fas fa-border-style", "fas fa-bowling-ball", "fas fa-box", "fas fa-box-open", "fas fa-box-tissue", "fas fa-boxes", "fas fa-braille", "fas fa-brain", "fas fa-bread-slice", "fas fa-briefcase", "fas fa-briefcase-medical", "fas fa-broadcast-tower", "fas fa-broom", "fas fa-brush", "fas fa-bug", "fas fa-building", "fas fa-bullhorn", "fas fa-bullseye", "fas fa-burn", "fas fa-bus", "fas fa-bus-alt", "fas fa-business-time", "fas fa-calculator", "fas fa-calendar", "fas fa-calendar-alt", "fas fa-calendar-check", "fas fa-calendar-day", "fas fa-calendar-minus", "fas fa-calendar-plus", "fas fa-calendar-times", "fas fa-calendar-week", "fas fa-camera", "fas fa-camera-retro", "fas fa-campground", "fas fa-candy-cane", "fas fa-cannabis", "fas fa-capsules", "fas fa-car", "fas fa-car-alt", "fas fa-car-battery", "fas fa-car-crash", "fas fa-car-side", "fas fa-caravan", "fas fa-caret-down", "fas fa-caret-left", "fas fa-caret-right", "fas fa-caret-square-down", "fas fa-caret-square-left", "fas fa-caret-square-right", "fas fa-caret-square-up", "fas fa-caret-up", "fas fa-carrot", "fas fa-cart-arrow-down", "fas fa-cart-plus", "fas fa-cash-register", "fas fa-cat", "fas fa-certificate", "fas fa-chair", "fas fa-chalkboard", "fas fa-chalkboard-teacher", "fas fa-charging-station", "fas fa-chart-area", "fas fa-chart-bar", "fas fa-chart-line", "fas fa-chart-pie", "fas fa-check", "fas fa-check-circle", "fas fa-check-double", "fas fa-check-square", "fas fa-cheese", "fas fa-chess", "fas fa-chess-bishop", "fas fa-chess-board", "fas fa-chess-king", "fas fa-chess-knight", "fas fa-chess-pawn", "fas fa-chess-queen", "fas fa-chess-rook", "fas fa-chevron-circle-down", "fas fa-chevron-circle-left", "fas fa-chevron-circle-right", "fas fa-chevron-circle-up", "fas fa-chevron-down", "fas fa-chevron-left", "fas fa-chevron-right", "fas fa-chevron-up", "fas fa-child", "fas fa-church", "fas fa-circle", "fas fa-circle-notch", "fas fa-city", "fas fa-clinic-medical", "fas fa-clipboard", "fas fa-clipboard-check", "fas fa-clipboard-list", "fas fa-clock", "fas fa-clone", "fas fa-closed-captioning", "fas fa-cloud", "fas fa-cloud-download-alt", "fas fa-cloud-meatball", "fas fa-cloud-moon", "fas fa-cloud-moon-rain", "fas fa-cloud-rain", "fas fa-cloud-showers-heavy", "fas fa-cloud-sun", "fas fa-cloud-sun-rain", "fas fa-cloud-upload-alt", "fas fa-cocktail", "fas fa-code", "fas fa-code-branch", "fas fa-coffee", "fas fa-cog", "fas fa-cogs", "fas fa-coins", "fas fa-columns", "fas fa-comment", "fas fa-comment-alt", "fas fa-comment-dollar", "fas fa-comment-dots", "fas fa-comment-medical", "fas fa-comment-slash", "fas fa-comments", "fas fa-comments-dollar", "fas fa-compact-disc", "fas fa-compass", "fas fa-compress", "fas fa-compress-alt", "fas fa-compress-arrows-alt", "fas fa-concierge-bell", "fas fa-cookie", "fas fa-cookie-bite", "fas fa-copy", "fas fa-copyright", "fas fa-couch", "fas fa-credit-card", "fas fa-crop", "fas fa-crop-alt", "fas fa-cross", "fas fa-crosshairs", "fas fa-crow", "fas fa-crown", "fas fa-crutch", "fas fa-cube", "fas fa-cubes", "fas fa-cut", "fas fa-database", "fas fa-deaf", "fas fa-democrat", "fas fa-desktop", "fas fa-dharmachakra", "fas fa-diagnoses", "fas fa-dice", "fas fa-dice-d20", "fas fa-dice-d6", "fas fa-dice-five", "fas fa-dice-four", "fas fa-dice-one", "fas fa-dice-six", "fas fa-dice-three", "fas fa-dice-two", "fas fa-digital-tachograph", "fas fa-directions", "fas fa-disease", "fas fa-divide", "fas fa-dizzy", "fas fa-dna", "fas fa-dog", "fas fa-dollar-sign", "fas fa-dolly", "fas fa-dolly-flatbed", "fas fa-donate", "fas fa-door-closed", "fas fa-door-open", "fas fa-dot-circle", "fas fa-dove", "fas fa-download", "fas fa-drafting-compass", "fas fa-dragon", "fas fa-draw-polygon", "fas fa-drum", "fas fa-drum-steelpan", "fas fa-drumstick-bite", "fas fa-dumbbell", "fas fa-dumpster", "fas fa-dumpster-fire", "fas fa-dungeon", "fas fa-edit", "fas fa-egg", "fas fa-eject", "fas fa-ellipsis-h", "fas fa-ellipsis-v", "fas fa-envelope", "fas fa-envelope-open", "fas fa-envelope-open-text", "fas fa-envelope-square", "fas fa-equals", "fas fa-eraser", "fas fa-ethernet", "fas fa-euro-sign", "fas fa-exchange-alt", "fas fa-exclamation", "fas fa-exclamation-circle", "fas fa-exclamation-triangle", "fas fa-expand", "fas fa-expand-alt", "fas fa-expand-arrows-alt", "fas fa-external-link-alt", "fas fa-external-link-square-alt", "fas fa-eye", "fas fa-eye-dropper", "fas fa-eye-slash", "fas fa-fan", "fas fa-fast-backward", "fas fa-fast-forward", "fas fa-faucet", "fas fa-fax", "fas fa-feather", "fas fa-feather-alt", "fas fa-female", "fas fa-fighter-jet", "fas fa-file", "fas fa-file-alt", "fas fa-file-archive", "fas fa-file-audio", "fas fa-file-code", "fas fa-file-contract", "fas fa-file-csv", "fas fa-file-download", "fas fa-file-excel", "fas fa-file-export", "fas fa-file-image", "fas fa-file-import", "fas fa-file-invoice", "fas fa-file-invoice-dollar", "fas fa-file-medical", "fas fa-file-medical-alt", "fas fa-file-pdf", "fas fa-file-powerpoint", "fas fa-file-prescription", "fas fa-file-signature", "fas fa-file-upload", "fas fa-file-video", "fas fa-file-word", "fas fa-fill", "fas fa-fill-drip", "fas fa-film", "fas fa-filter", "fas fa-fingerprint", "fas fa-fire", "fas fa-fire-alt", "fas fa-fire-extinguisher", "fas fa-first-aid", "fas fa-fish", "fas fa-fist-raised", "fas fa-flag", "fas fa-flag-checkered", "fas fa-flag-usa", "fas fa-flask", "fas fa-flushed", "fas fa-folder", "fas fa-folder-minus", "fas fa-folder-open", "fas fa-folder-plus", "fas fa-font", "fas fa-football-ball", "fas fa-forward", "fas fa-frog", "fas fa-frown", "fas fa-frown-open", "fas fa-funnel-dollar", "fas fa-futbol", "fas fa-gamepad", "fas fa-gas-pump", "fas fa-gavel", "fas fa-gem", "fas fa-genderless", "fas fa-ghost", "fas fa-gift", "fas fa-gifts", "fas fa-glass-cheers", "fas fa-glass-martini", "fas fa-glass-martini-alt", "fas fa-glass-whiskey", "fas fa-glasses", "fas fa-globe", "fas fa-globe-africa", "fas fa-globe-americas", "fas fa-globe-asia", "fas fa-globe-europe", "fas fa-golf-ball", "fas fa-gopuram", "fas fa-graduation-cap", "fas fa-greater-than", "fas fa-greater-than-equal", "fas fa-grimace", "fas fa-grin", "fas fa-grin-alt", "fas fa-grin-beam", "fas fa-grin-beam-sweat", "fas fa-grin-hearts", "fas fa-grin-squint", "fas fa-grin-squint-tears", "fas fa-grin-stars", "fas fa-grin-tears", "fas fa-grin-tongue", "fas fa-grin-tongue-squint", "fas fa-grin-tongue-wink", "fas fa-grin-wink", "fas fa-grip-horizontal", "fas fa-grip-lines", "fas fa-grip-lines-vertical", "fas fa-grip-vertical", "fas fa-guitar", "fas fa-h-square", "fas fa-hamburger", "fas fa-hammer", "fas fa-hamsa", "fas fa-hand-holding", "fas fa-hand-holding-heart", "fas fa-hand-holding-medical", "fas fa-hand-holding-usd", "fas fa-hand-holding-water", "fas fa-hand-lizard", "fas fa-hand-middle-finger", "fas fa-hand-paper", "fas fa-hand-peace", "fas fa-hand-point-down", "fas fa-hand-point-left", "fas fa-hand-point-right", "fas fa-hand-point-up", "fas fa-hand-pointer", "fas fa-hand-rock", "fas fa-hand-scissors", "fas fa-hand-sparkles", "fas fa-hand-spock", "fas fa-hands", "fas fa-hands-helping", "fas fa-hands-wash", "fas fa-handshake", "fas fa-handshake-alt-slash", "fas fa-handshake-slash", "fas fa-hanukiah", "fas fa-hard-hat", "fas fa-hashtag", "fas fa-hat-cowboy", "fas fa-hat-cowboy-side", "fas fa-hat-wizard", "fas fa-hdd", "fas fa-head-side-cough", "fas fa-head-side-cough-slash", "fas fa-head-side-mask", "fas fa-head-side-virus", "fas fa-heading", "fas fa-headphones", "fas fa-headphones-alt", "fas fa-headset", "fas fa-heart", "fas fa-heart-broken", "fas fa-heartbeat", "fas fa-helicopter", "fas fa-highlighter", "fas fa-hiking", "fas fa-hippo", "fas fa-history", "fas fa-hockey-puck", "fas fa-holly-berry", "fas fa-home", "fas fa-horse", "fas fa-horse-head", "fas fa-hospital", "fas fa-hospital-alt", "fas fa-hospital-symbol", "fas fa-hospital-user", "fas fa-hot-tub", "fas fa-hotdog", "fas fa-hotel", "fas fa-hourglass", "fas fa-hourglass-end", "fas fa-hourglass-half", "fas fa-hourglass-start", "fas fa-house-damage", "fas fa-house-user", "fas fa-hryvnia", "fas fa-i-cursor", "fas fa-ice-cream", "fas fa-icicles", "fas fa-icons", "fas fa-id-badge", "fas fa-id-card", "fas fa-id-card-alt", "fas fa-igloo", "fas fa-image", "fas fa-images", "fas fa-inbox", "fas fa-indent", "fas fa-industry", "fas fa-infinity", "fas fa-info", "fas fa-info-circle", "fas fa-italic", "fas fa-jedi", "fas fa-joint", "fas fa-journal-whills", "fas fa-kaaba", "fas fa-key", "fas fa-keyboard", "fas fa-khanda", "fas fa-kiss", "fas fa-kiss-beam", "fas fa-kiss-wink-heart", "fas fa-kiwi-bird", "fas fa-landmark", "fas fa-language", "fas fa-laptop", "fas fa-laptop-code", "fas fa-laptop-house", "fas fa-laptop-medical", "fas fa-laugh", "fas fa-laugh-beam", "fas fa-laugh-squint", "fas fa-laugh-wink", "fas fa-layer-group", "fas fa-leaf", "fas fa-lemon", "fas fa-less-than", "fas fa-less-than-equal", "fas fa-level-down-alt", "fas fa-level-up-alt", "fas fa-life-ring", "fas fa-lightbulb", "fas fa-link", "fas fa-lira-sign", "fas fa-list", "fas fa-list-alt", "fas fa-list-ol", "fas fa-list-ul", "fas fa-location-arrow", "fas fa-lock", "fas fa-lock-open", "fas fa-long-arrow-alt-down", "fas fa-long-arrow-alt-left", "fas fa-long-arrow-alt-right", "fas fa-long-arrow-alt-up", "fas fa-low-vision", "fas fa-luggage-cart", "fas fa-lungs", "fas fa-lungs-virus", "fas fa-magic", "fas fa-magnet", "fas fa-mail-bulk", "fas fa-male", "fas fa-map", "fas fa-map-marked", "fas fa-map-marked-alt", "fas fa-map-marker", "fas fa-map-marker-alt", "fas fa-map-pin", "fas fa-map-signs", "fas fa-marker", "fas fa-mars", "fas fa-mars-double", "fas fa-mars-stroke", "fas fa-mars-stroke-h", "fas fa-mars-stroke-v", "fas fa-mask", "fas fa-medal", "fas fa-medkit", "fas fa-meh", "fas fa-meh-blank", "fas fa-meh-rolling-eyes", "fas fa-memory", "fas fa-menorah", "fas fa-mercury", "fas fa-meteor", "fas fa-microchip", "fas fa-microphone", "fas fa-microphone-alt", "fas fa-microphone-alt-slash", "fas fa-microphone-slash", "fas fa-microscope", "fas fa-minus", "fas fa-minus-circle", "fas fa-minus-square", "fas fa-mitten", "fas fa-mobile", "fas fa-mobile-alt", "fas fa-money-bill", "fas fa-money-bill-alt", "fas fa-money-bill-wave", "fas fa-money-bill-wave-alt", "fas fa-money-check", "fas fa-money-check-alt", "fas fa-monument", "fas fa-moon", "fas fa-mortar-pestle", "fas fa-mosque", "fas fa-motorcycle", "fas fa-mountain", "fas fa-mouse", "fas fa-mouse-pointer", "fas fa-mug-hot", "fas fa-music", "fas fa-network-wired", "fas fa-neuter", "fas fa-newspaper", "fas fa-not-equal", "fas fa-notes-medical", "fas fa-object-group", "fas fa-object-ungroup", "fas fa-oil-can", "fas fa-om", "fas fa-otter", "fas fa-outdent", "fas fa-pager", "fas fa-paint-brush", "fas fa-paint-roller", "fas fa-palette", "fas fa-pallet", "fas fa-paper-plane", "fas fa-paperclip", "fas fa-parachute-box", "fas fa-paragraph", "fas fa-parking", "fas fa-passport", "fas fa-pastafarianism", "fas fa-paste", "fas fa-pause", "fas fa-pause-circle", "fas fa-paw", "fas fa-peace", "fas fa-pen", "fas fa-pen-alt", "fas fa-pen-fancy", "fas fa-pen-nib", "fas fa-pen-square", "fas fa-pencil-alt", "fas fa-pencil-ruler", "fas fa-people-arrows", "fas fa-people-carry", "fas fa-pepper-hot", "fas fa-percent", "fas fa-percentage", "fas fa-person-booth", "fas fa-phone", "fas fa-phone-alt", "fas fa-phone-slash", "fas fa-phone-square", "fas fa-phone-square-alt", "fas fa-phone-volume", "fas fa-photo-video", "fas fa-piggy-bank", "fas fa-pills", "fas fa-pizza-slice", "fas fa-place-of-worship", "fas fa-plane", "fas fa-plane-arrival", "fas fa-plane-departure", "fas fa-plane-slash", "fas fa-play", "fas fa-play-circle", "fas fa-plug", "fas fa-plus", "fas fa-plus-circle", "fas fa-plus-square", "fas fa-podcast", "fas fa-poll", "fas fa-poll-h", "fas fa-poo", "fas fa-poo-storm", "fas fa-poop", "fas fa-portrait", "fas fa-pound-sign", "fas fa-power-off", "fas fa-pray", "fas fa-praying-hands", "fas fa-prescription", "fas fa-prescription-bottle", "fas fa-prescription-bottle-alt", "fas fa-print", "fas fa-procedures", "fas fa-project-diagram", "fas fa-pump-medical", "fas fa-pump-soap", "fas fa-puzzle-piece", "fas fa-qrcode", "fas fa-question", "fas fa-question-circle", "fas fa-quidditch", "fas fa-quote-left", "fas fa-quote-right", "fas fa-quran", "fas fa-radiation", "fas fa-radiation-alt", "fas fa-rainbow", "fas fa-random", "fas fa-receipt", "fas fa-record-vinyl", "fas fa-recycle", "fas fa-redo", "fas fa-redo-alt", "fas fa-registered", "fas fa-remove-format", "fas fa-reply", "fas fa-reply-all", "fas fa-republican", "fas fa-restroom", "fas fa-retweet", "fas fa-ribbon", "fas fa-ring", "fas fa-road", "fas fa-robot", "fas fa-rocket", "fas fa-route", "fas fa-rss", "fas fa-rss-square", "fas fa-ruble-sign", "fas fa-ruler", "fas fa-ruler-combined", "fas fa-ruler-horizontal", "fas fa-ruler-vertical", "fas fa-running", "fas fa-rupee-sign", "fas fa-sad-cry", "fas fa-sad-tear", "fas fa-satellite", "fas fa-satellite-dish", "fas fa-save", "fas fa-school", "fas fa-screwdriver", "fas fa-scroll", "fas fa-sd-card", "fas fa-search", "fas fa-search-dollar", "fas fa-search-location", "fas fa-search-minus", "fas fa-search-plus", "fas fa-seedling", "fas fa-server", "fas fa-shapes", "fas fa-share", "fas fa-share-alt", "fas fa-share-alt-square", "fas fa-share-square", "fas fa-shekel-sign", "fas fa-shield-alt", "fas fa-shield-virus", "fas fa-ship", "fas fa-shipping-fast", "fas fa-shoe-prints", "fas fa-shopping-bag", "fas fa-shopping-basket", "fas fa-shopping-cart", "fas fa-shower", "fas fa-shuttle-van", "fas fa-sign", "fas fa-sign-in-alt", "fas fa-sign-language", "fas fa-sign-out-alt", "fas fa-signal", "fas fa-signature", "fas fa-sim-card", "fas fa-sink", "fas fa-sitemap", "fas fa-skating", "fas fa-skiing", "fas fa-skiing-nordic", "fas fa-skull", "fas fa-skull-crossbones", "fas fa-slash", "fas fa-sleigh", "fas fa-sliders-h", "fas fa-smile", "fas fa-smile-beam", "fas fa-smile-wink", "fas fa-smog", "fas fa-smoking", "fas fa-smoking-ban", "fas fa-sms", "fas fa-snowboarding", "fas fa-snowflake", "fas fa-snowman", "fas fa-snowplow", "fas fa-soap", "fas fa-socks", "fas fa-solar-panel", "fas fa-sort", "fas fa-sort-alpha-down", "fas fa-sort-alpha-down-alt", "fas fa-sort-alpha-up", "fas fa-sort-alpha-up-alt", "fas fa-sort-amount-down", "fas fa-sort-amount-down-alt", "fas fa-sort-amount-up", "fas fa-sort-amount-up-alt", "fas fa-sort-down", "fas fa-sort-numeric-down", "fas fa-sort-numeric-down-alt", "fas fa-sort-numeric-up", "fas fa-sort-numeric-up-alt", "fas fa-sort-up", "fas fa-spa", "fas fa-space-shuttle", "fas fa-spell-check", "fas fa-spider", "fas fa-spinner", "fas fa-splotch", "fas fa-spray-can", "fas fa-square", "fas fa-square-full", "fas fa-square-root-alt", "fas fa-stamp", "fas fa-star", "fas fa-star-and-crescent", "fas fa-star-half", "fas fa-star-half-alt", "fas fa-star-of-david", "fas fa-star-of-life", "fas fa-step-backward", "fas fa-step-forward", "fas fa-stethoscope", "fas fa-sticky-note", "fas fa-stop", "fas fa-stop-circle", "fas fa-stopwatch", "fas fa-stopwatch-20", "fas fa-store", "fas fa-store-alt", "fas fa-store-alt-slash", "fas fa-store-slash", "fas fa-stream", "fas fa-street-view", "fas fa-strikethrough", "fas fa-stroopwafel", "fas fa-subscript", "fas fa-subway", "fas fa-suitcase", "fas fa-suitcase-rolling", "fas fa-sun", "fas fa-superscript", "fas fa-surprise", "fas fa-swatchbook", "fas fa-swimmer", "fas fa-swimming-pool", "fas fa-synagogue", "fas fa-sync", "fas fa-sync-alt", "fas fa-syringe", "fas fa-table", "fas fa-table-tennis", "fas fa-tablet", "fas fa-tablet-alt", "fas fa-tablets", "fas fa-tachometer-alt", "fas fa-tag", "fas fa-tags", "fas fa-tape", "fas fa-tasks", "fas fa-taxi", "fas fa-teeth", "fas fa-teeth-open", "fas fa-temperature-high", "fas fa-temperature-low", "fas fa-tenge", "fas fa-terminal", "fas fa-text-height", "fas fa-text-width", "fas fa-th", "fas fa-th-large", "fas fa-th-list", "fas fa-theater-masks", "fas fa-thermometer", "fas fa-thermometer-empty", "fas fa-thermometer-full", "fas fa-thermometer-half", "fas fa-thermometer-quarter", "fas fa-thermometer-three-quarters", "fas fa-thumbs-down", "fas fa-thumbs-up", "fas fa-thumbtack", "fas fa-ticket-alt", "fas fa-times", "fas fa-times-circle", "fas fa-tint", "fas fa-tint-slash", "fas fa-tired", "fas fa-toggle-off", "fas fa-toggle-on", "fas fa-toilet", "fas fa-toilet-paper", "fas fa-toilet-paper-slash", "fas fa-toolbox", "fas fa-tools", "fas fa-tooth", "fas fa-torah", "fas fa-torii-gate", "fas fa-tractor", "fas fa-trademark", "fas fa-traffic-light", "fas fa-trailer", "fas fa-train", "fas fa-tram", "fas fa-transgender", "fas fa-transgender-alt", "fas fa-trash", "fas fa-trash-alt", "fas fa-trash-restore", "fas fa-trash-restore-alt", "fas fa-tree", "fas fa-trophy", "fas fa-truck", "fas fa-truck-loading", "fas fa-truck-monster", "fas fa-truck-moving", "fas fa-truck-pickup", "fas fa-tshirt", "fas fa-tty", "fas fa-tv", "fas fa-umbrella", "fas fa-umbrella-beach", "fas fa-underline", "fas fa-undo", "fas fa-undo-alt", "fas fa-universal-access", "fas fa-university", "fas fa-unlink", "fas fa-unlock", "fas fa-unlock-alt", "fas fa-upload", "fas fa-user", "fas fa-user-alt", "fas fa-user-alt-slash", "fas fa-user-astronaut", "fas fa-user-check", "fas fa-user-circle", "fas fa-user-clock", "fas fa-user-cog", "fas fa-user-edit", "fas fa-user-friends", "fas fa-user-graduate", "fas fa-user-injured", "fas fa-user-lock", "fas fa-user-md", "fas fa-user-minus", "fas fa-user-ninja", "fas fa-user-nurse", "fas fa-user-plus", "fas fa-user-secret", "fas fa-user-shield", "fas fa-user-slash", "fas fa-user-tag", "fas fa-user-tie", "fas fa-user-times", "fas fa-users", "fas fa-users-cog", "fas fa-users-slash", "fas fa-utensil-spoon", "fas fa-utensils", "fas fa-vector-square", "fas fa-venus", "fas fa-venus-double", "fas fa-venus-mars", "fas fa-vest", "fas fa-vest-patches", "fas fa-vial", "fas fa-vials", "fas fa-video", "fas fa-video-slash", "fas fa-vihara", "fas fa-virus", "fas fa-virus-slash", "fas fa-viruses", "fas fa-voicemail", "fas fa-volleyball-ball", "fas fa-volume-down", "fas fa-volume-mute", "fas fa-volume-off", "fas fa-volume-up", "fas fa-vote-yea", "fas fa-vr-cardboard", "fas fa-walking", "fas fa-wallet", "fas fa-warehouse", "fas fa-water", "fas fa-wave-square", "fas fa-weight", "fas fa-weight-hanging", "fas fa-wheelchair", "fas fa-wifi", "fas fa-wind", "fas fa-window-close", "fas fa-window-maximize", "fas fa-window-minimize", "fas fa-window-restore", "fas fa-wine-bottle", "fas fa-wine-glass", "fas fa-wine-glass-alt", "fas fa-won-sign", "fas fa-wrench", "fas fa-x-ray", "fas fa-yen-sign", "fas fa-yin-yang"
]
export const FaIcons = FaSolidIcon.concat(FaRegularIcon, FaBrandsIcon)

// Bluprint icon list
export const blueprintIcons = [
    "add-child", "add-clip", "add-column-left", "add-column-right", "add-location", "add-parent", "add-row-bottom", "add-row-top", "add-to-artifact", "add-to-folder", "add", "aimpoints-target", "airplane", "align-center", "align-justify", "align-left", "align-right", "alignment-bottom", "alignment-horizontal-center", "alignment-left", "alignment-right", "alignment-top", "alignment-vertical-center", "ammunition", "anchor", "annotation", "announcement", "antenna", "app-header", "application", "applications", "archive", "area-of-interest", "array-boolean", "array-date", "array-floating-point", "array-numeric", "array-object", "array-string", "array-timestamp", "array", "arrow-bottom-left", "arrow-bottom-right", "arrow-down", "arrow-left", "arrow-right", "arrow-top-left", "arrow-top-right", "arrow-up", "arrows-arc", "arrows-horizontal", "arrows-vertical", "asterisk", "at", "automatic-updates", "axle", "backlink", "backward-ten", "badge", "ban-circle", "bank-account", "barcode", "binary-number", "blank", "block-promote", "blocked-person", "bold", "book", "bookmark", "box", "briefcase", "bring-data", "bring-forward", "british-pound", "bug", "buggy", "build", "bullseye", "calculator", "calendar", "camera", "caret-down", "caret-left", "caret-right", "caret-up", "cargo-ship", "cell-tower", "changes", "chart", "chat", "chevron-backward", "chevron-down", "chevron-forward", "chevron-left", "chevron-right", "chevron-up", "circle-arrow-down", "circle-arrow-left", "circle-arrow-right", "circle-arrow-up", "circle", "citation", "clean", "clip", "clipboard-file", "clipboard", "cloud-download", "cloud-server", "cloud-tick", "cloud-upload", "cloud", "code-block", "code", "cog", "collapse-all", "color-fill", "column-layout", "comment", "comparison", "compass", "compressed", "confirm", "console", "construction", "contrast", "control", "credit-card", "crop", "cross-circle", "cross", "crown", "css-style", "cube-add", "cube-edit", "cube-remove", "cube", "cubes", "curly-braces", "curved-range-chart", "cut", "cycle", "dashboard", "data-cloud", "data-connection", "data-lineage", "data-search", "data-sync", "database", "delete-clip", "delete", "delta", "derive-column", "desktop", "detection", "diagnosis", "diagram-tree", "direction-left", "direction-right", "disable", "divide", "document-code", "document-locked", "document-open", "document-share", "document", "dollar", "dot", "double-caret-horizontal", "double-caret-vertical", "double-chevron-down", "double-chevron-left", "double-chevron-right", "double-chevron-up", "doughnut-chart", "download", "drag-handle-horizontal", "drag-handle-vertical", "draw", "drawer-left-filled", "drawer-left", "drawer-right-filled", "drawer-right", "drive-time", "duplicate", "edit", "eject", "emoji", "endnote", "endorsed", "envelope", "equals", "eraser", "error", "euro", "excavator", "exchange", "exclude-row", "expand-all", "explain", "export", "eye-off", "eye-on", "eye-open", "fast-backward", "fast-forward", "feed-subscribed", "feed", "fighter-jet", "film", "filter-keep", "filter-list", "filter-open", "filter-remove", "filter-sort-asc", "filter-sort-desc", "filter", "flag", "flame", "flash", "floating-point", "floppy-disk", "flow-branch", "flow-end", "flow-linear", "flow-review-branch", "flow-review", "flows", "folder-close", "folder-new", "folder-open", "folder-shared-open", "folder-shared", "follower", "following", "font", "fork", "form", "forward-ten", "fuel", "full-circle", "full-stacked-chart", "fullscreen", "function", "gantt-chart", "generate", "geofence", "geolocation", "geosearch", "geotime", "gift-box", "git-branch", "git-commit", "git-merge", "git-new-branch", "git-pull", "git-push", "git-repo", "glass", "globe-network-add", "globe-network", "globe", "graph-remove", "graph", "greater-than-or-equal-to", "greater-than", "grid-view", "grid", "group-item", "group-objects", "grouped-bar-chart", "hand-down", "hand-left", "hand-right", "hand-up", "hand", "hat", "header-one", "header-three", "header-two", "header", "headset", "heart-broken", "heart", "heat-grid", "heatmap", "helicopter", "help", "helper-management", "hexagon", "high-priority", "high-voltage-pole", "highlight", "history", "home", "horizontal-bar-chart-asc", "horizontal-bar-chart-desc", "horizontal-bar-chart", "horizontal-distribution", "horizontal-inbetween", "hurricane", "id-number", "image-rotate-left", "image-rotate-right", "import", "inbox-filtered", "inbox-geo", "inbox-search", "inbox-update", "inbox", "info-sign", "inheritance", "inherited-group", "inner-join", "input", "insert", "intelligence", "intersection", "ip-address", "issue-closed", "issue-new", "issue", "italic", "join-table", "key-backspace", "key-command", "key-control", "key-delete", "key-enter", "key-escape", "key-option", "key-shift", "key-tab", "key", "known-vehicle", "lab-test", "label", "layer-outline", "layer", "layers", "layout-auto", "layout-balloon", "layout-bottom-row-three-tiles", "layout-bottom-row-two-tiles", "layout-circle", "layout-grid", "layout-group-by", "layout-hierarchy", "layout-left-column-three-tiles", "layout-left-column-two-tiles", "layout-linear", "layout-right-column-three-tiles", "layout-right-column-two-tiles", "layout-skew-grid", "layout-sorted-clusters", "layout-three-columns", "layout-three-rows", "layout-top-row-three-tiles", "layout-top-row-two-tiles", "layout-two-columns", "layout-two-rows", "layout", "learning", "left-join", "lengthen-text", "less-than-or-equal-to", "less-than", "lifesaver", "lightbulb", "lightning", "link", "linked-squares", "list-columns", "list-detail-view", "list", "locate", "lock", "locomotive", "log-in", "log-out", "low-voltage-pole", "manual", "manually-entered-data", "many-to-many", "many-to-one", "map-create", "map-marker", "map", "maximize", "media", "menu-closed", "menu-open", "menu", "merge-columns", "merge-links", "microphone", "minimize", "minus", "mobile-phone", "mobile-video", "modal-filled", "modal", "model", "moon", "more", "mountain", "move", "mugshot", "multi-select", "music", "nest", "new-drawing", "new-grid-item", "new-layer", "new-layers", "new-link", "new-object", "new-person", "new-prescription", "new-shield", "new-text-box", "ninja", "not-equal-to", "notifications-add", "notifications-snooze", "notifications-updated", "notifications", "numbered-list", "numerical", "object-view", "office", "offline", "oil-field", "one-column", "one-to-many", "one-to-one", "open-application", "outdated", "output", "package", "page-break", "page-layout", "panel-stats", "panel-table", "panel", "paperclip", "paragraph", "paste-variable", "path-search", "path", "pause", "people", "percentage", "person", "phone-call", "phone-forward", "phone-search", "phone", "pie-chart", "pill", "pin", "pistol", "pivot-table", "pivot", "play", "playbook", "plus", "polygon-filter", "power", "predictive-analysis", "prescription", "presentation", "print", "projects", "properties", "property", "publish-function", "pulse", "rain", "random", "range-ring", "record", "rect-height", "rect-width", "rectangle", "redo", "refresh", "regex", "regression-chart", "remove-column-left", "remove-column-right", "remove-column", "remove-row-bottom", "remove-row-top", "remove", "repeat", "reset", "resolve", "rig", "right-join", "ring", "rocket-slant", "rocket", "root-folder", "rotate-ccw", "rotate-cw", "rotate-document", "rotate-page", "route", "run-history", "satellite", "saved", "scatter-plot", "search-around", "search-template", "search-text", "search", "segmented-control", "select", "selection-box-add", "selection-box-edit", "selection-box", "selection", "send-backward", "send-message", "send-to-graph", "send-to-map", "send-to", "sensor", "series-add", "series-configuration", "series-derived", "series-filtered", "series-search", "server-install", "server", "settings", "shapes", "share", "shared-filter", "shield", "ship", "shop", "shopping-cart", "shorten-text", "signal-search", "sim-card", "slash", "small-cross", "small-info-sign", "small-minus", "small-plus", "small-square", "small-tick", "snowflake", "soccer-ball", "social-media", "sort-alphabetical-desc", "sort-alphabetical", "sort-asc", "sort-desc", "sort-numerical-desc", "sort-numerical", "sort", "spell-check", "split-columns", "sports-stadium", "square", "stacked-chart", "stadium-geometry", "star-empty", "star", "step-backward", "step-chart", "step-forward", "stop", "stopwatch", "strikethrough", "style", "subscript", "subtract-right-join", "superscript", "swap-horizontal", "swap-vertical", "sweep", "switch", "symbol-circle", "symbol-cross", "symbol-diamond", "symbol-rectangle", "symbol-square", "symbol-triangle-down", "symbol-triangle-up", "syringe", "table-sync", "tag-add", "tag-promote", "tag-refresh", "tag-undo", "tag", "tags", "take-action", "tank", "target", "taxi", "team", "temperature", "text-highlight", "th-add", "th-derived", "th-disconnect", "th-filtered", "th-list-add", "th-list", "th-virtual-add", "th-virtual", "th", "third-party", "thumbs-down", "thumbs-up", "tick-circle", "tick", "time", "timeline-area-chart", "timeline-bar-chart", "timeline-events", "timeline-line-chart", "tint", "torch", "tractor", "train", "translate", "trash", "tree", "trending-down", "trending-up", "trophy", "truck", "two-columns", "unarchive", "underline", "undo", "ungroup-objects", "unknown-vehicle", "unlink", "unlock", "unpin", "unresolve", "updated", "upload", "user", "variable", "vector", "vertical-bar-chart-asc", "vertical-bar-chart-desc", "vertical-distribution", "vertical-inbetween", "video", "virus", "volume-down", "volume-off", "volume-up", "walk", "warning-sign", "waterfall-chart", "waves", "widget-button", "widget-footer", "widget-header", "widget", "wind", "wrench-redo", "wrench-snooze", "wrench-time", "wrench", "zoom-in", "zoom-out", "zoom-to-fit"
]